/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Either protein or dna
 * @export
 */
export const SequenceType = {
  protein: "protein",
  dna: "dna",
} as const;
export type SequenceType = (typeof SequenceType)[keyof typeof SequenceType];

export function SequenceTypeFromJSON(json: any): SequenceType {
  return SequenceTypeFromJSONTyped(json, false);
}

export function SequenceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequenceType {
  return json as SequenceType;
}

export function SequenceTypeToJSON(value?: SequenceType | null): any {
  return value as any;
}
